export default "__VITE_ASSET__Jbpo5x3e__"